import { render, staticRenderFns } from "./exceptionRecord.vue?vue&type=template&id=7070a955&scoped=true&"
import script from "./exceptionRecord.vue?vue&type=script&lang=js&"
export * from "./exceptionRecord.vue?vue&type=script&lang=js&"
import style0 from "./exceptionRecord.vue?vue&type=style&index=0&id=7070a955&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7070a955",
  null
  
)

export default component.exports